function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AnimatePresence } from 'framer-motion';
import { Portal } from 'react-portal';
import Theme from '../Theme';
import { containerVariants, overlayVariants, dialogVariants } from './animation';
/**
 * A Modal is displayed through a Portal added at the end of the body element. An overlay hides
 * everything expect the modal itself. Action when clicking on the overlay can be used to
 * control modal display.
 * Modal can be used to display additional informations to the user, or ask for user input.
 *
 * @return {jsx}
 */

import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import { Container, Overlay, Dialog, Title } from './elements';
var node = PropTypes.node,
    string = PropTypes.string,
    bool = PropTypes.bool,
    func = PropTypes.func;

var Modal = /*#__PURE__*/function (_PureComponent) {
  _inherits(Modal, _PureComponent);

  var _super = _createSuper(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "render",
    value:
    /**
     * Render function
     */
    function render() {
      var _this$props = this.props,
          className = _this$props.className,
          active = _this$props.active,
          width = _this$props.width,
          height = _this$props.height,
          padding = _this$props.padding,
          onOverlayClick = _this$props.onOverlayClick,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(AnimatePresence, null, active && /*#__PURE__*/React.createElement(Container, {
        className: className,
        key: "Container",
        initial: "hidden",
        animate: "visible",
        exit: "hidden",
        variants: containerVariants
      }, /*#__PURE__*/React.createElement(Overlay, {
        onClick: onOverlayClick,
        variants: overlayVariants,
        key: "Overlay",
        "data-testid": "overlay"
      }), /*#__PURE__*/React.createElement(Dialog, {
        width: width,
        height: height,
        padding: padding,
        key: "Dialog",
        variants: dialogVariants
      }, children))));
    }
  }]);

  return Modal;
}(PureComponent);
/**
 * PropTypes validation
 */


_defineProperty(Modal, "Header", Header);

_defineProperty(Modal, "Body", Body);

_defineProperty(Modal, "Footer", Footer);

_defineProperty(Modal, "Title", Title);

Modal.propTypes = {
  /**
   * Displays or hides the modal
   */
  active: bool,

  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment)
   */
  children: node,

  /**
   * Classname of Modal container
   */
  className: string,

  /**
   * Modal height
   */
  height: string,

  /**
   * Callback triggered when overlay is clicked by the user
   */
  onOverlayClick: func,

  /**
   * Modal padding
   */
  padding: string,

  /**
   * Modal width
   */
  width: string
};
/**
 * Default propTypes
 */

Modal.defaultProps = {
  active: false,
  children: null,
  className: null,
  height: '39rem',
  onOverlayClick: function onOverlayClick() {},
  padding: Theme.dimensions.medium,
  width: '48rem'
};
export default Modal;